const config = {
  API_BASE_URL: "/api",
  ORIGIN: `http://${window.location.hostname}:8000`,
};

export default config;
